export default __webpack_public_path__ + "assets/images/icon-go-back.0aeda990ba06ed4981899eb97b566dce.svg";